// Recovered compiled webpack factory 84767. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  (a.r(t), a.d(t, { ChromeButton: () => d }));
  var r = a(95155),
    n = a(52619),
    i = a.n(n),
    s = a(33021),
    o = a(65025),
    l = a(52273),
    c = a.n(l);
  function d(e) {
    let { href: t, children: a, className: n = "", track: l } = e,
      d = /^https?:\/\//.test(t),
      m = `${o.EC} ${c().cta} inline-flex items-center justify-center squircle-md font-medium text-white no-underline [text-shadow:0_1px_1px_rgba(0,0,0,0.22)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#FD6421] ${n}`;
    return d
      ? (0, r.jsx)("a", {
          href: t,
          target: "_blank",
          rel: "noopener noreferrer",
          className: m,
          "data-track-cta": l,
          children: a,
        })
      : (0, r.jsx)(i(), {
          href: t,
          prefetch: t !== s.Wd && void 0,
          className: m,
          "data-track-cta": l,
          children: a,
        });
  }
}
